export default "__VITE_ASSET__CcPIt5Kk__"